module.exports = __webpack_public_path__ + "img-front/ok.084a5f2d.png";